
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AllLabels } from '@/interfaces';
import { DateWrapper, graphElapsedTimeFormat } from '@/utils';
import { labelsStore, settingsStore } from '@/store';
import { ITimelineDataPoint } from './data';

interface IDisplayPoint {
  time: string;
  text: string;
  key: string;
}

@Component({
})
export default class HubblePlotAlarmTooltip extends Vue {
  
  public offset: number = 10;
  public positionX: string = '0px';
  public positionY: string = '0px';

  @Prop({required: true})
  public points!: ITimelineDataPoint[];

  @Prop({required: true})
  public startTime!: DateWrapper;

  @Prop({required: true})
  public anchorX!: number;

  @Prop({required: true})
  public anchorY!: number;

  @Watch("anchorX")
  public onAnchorXUpdate(): void {
    this._updatePositionX();
  }

  @Watch("anchorY")
  public onAnchorYUpdate(): void {
    this._updatePositionY();
  }

  public mounted(): void {
    this._updatePositionX();
    this._updatePositionY();
  }

  public get labels(): AllLabels {
    return labelsStore.labels;
  }

  public get displayPoints(): IDisplayPoint[] {
    return this.points.map(x => this._getDisplayPoint(x));
  }

  private _getDisplayPoint(point: ITimelineDataPoint): IDisplayPoint {
    return {
      time: this._getTime(point),
      text: this._getText(point),
      key: this._getKey(point)
    };
  }

  private _getTime(point: ITimelineDataPoint): string {
    const relativeTime = graphElapsedTimeFormat(point.timeMs);
    const absoluteTime = this.startTime.plusMilliseconds(point.timeMs).toDisplayDateTime(settingsStore.use12HourClock);
    return `${relativeTime} (${absoluteTime})`;
  }

  private _getText(point: ITimelineDataPoint): string {
    return point.timelineItem.message;
  }

  private _getKey(point: ITimelineDataPoint): string {
    return point.timelineItem.key || (point.timelineItem.timeMs + point.timelineItem.message);
  }

  private _updatePositionX(): void {
    const width = this.$el?.getBoundingClientRect().width ?? 0;
    let left = this.anchorX + this.offset;
    let right = left + width;
    if (window.innerWidth - right < 20) {
      // not enough space on the right of the hover, put it on the left
      left = this.anchorX - width - this.offset;
    }
    this.positionX = left + 'px';
  }

  private _updatePositionY(): void {
    const height = this.$el?.getBoundingClientRect().height ?? 0;
    const top = this.anchorY - height / 2;
    this.positionY = top + 'px';
  }
}

